import styled from 'styled-components'

export const Wrapper = styled.div``

export const ActionsContainer = styled.div`
  .input {
    width: 40%;
  }
`
